<script setup></script>

<template>
  <div class="container container--main">
    <MtgsNs />
    <slot />
  </div>
</template>

<style lang="scss" scoped></style>
